"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderUpdateStatusEnum = void 0;
var OrderUpdateStatusEnum;
(function (OrderUpdateStatusEnum) {
    OrderUpdateStatusEnum["NotSubmitted"] = "not_submitted";
    OrderUpdateStatusEnum["Submitting"] = "submitting";
    OrderUpdateStatusEnum["Submitted"] = "submitted";
    OrderUpdateStatusEnum["Error"] = "error";
    OrderUpdateStatusEnum["Retry"] = "retry";
    OrderUpdateStatusEnum["MaxRetryAttemptsError"] = "error_max_retry_attempts";
})(OrderUpdateStatusEnum = exports.OrderUpdateStatusEnum || (exports.OrderUpdateStatusEnum = {}));
//# sourceMappingURL=order-update-status.enum.js.map